import { render, staticRenderFns } from "./HonorariosExitoYProduccion.vue?vue&type=template&id=47472c62"
import script from "./HonorariosExitoYProduccion.vue?vue&type=script&lang=js"
export * from "./HonorariosExitoYProduccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports